import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex justify-content-center align-items-center",
  style: {"min-height":"220px"}
}
const _hoisted_2 = { class: "p-15 p-md-20 border-bottom d-flex flex-wrap align-items-center justify-content-between gap-2" }
const _hoisted_3 = { class: "d-flex align-items-center gap-2 flex-wrap" }
const _hoisted_4 = { class: "position-relative" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 0,
  class: "spinner-border spinner-border-sm"
}
const _hoisted_7 = {
  key: 1,
  class: "ri-bar-chart-2-line"
}
const _hoisted_8 = { class: "card-body p-0" }
const _hoisted_9 = { class: "table-scroll-outer" }
const _hoisted_10 = { class: "table-scroll-mobile" }
const _hoisted_11 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "ps-20 text-muted fs-13" }
const _hoisted_14 = ["src", "alt", "onError"]
const _hoisted_15 = { class: "fw-semibold fs-14 d-block" }
const _hoisted_16 = { class: "text-muted fs-12" }
const _hoisted_17 = {
  key: 0,
  class: "text-muted fs-12 ms-1"
}
const _hoisted_18 = { class: "fs-13" }
const _hoisted_19 = { class: "d-flex flex-column gap-1" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_22 = {
  key: 2,
  class: "text-muted"
}
const _hoisted_23 = { class: "switch" }
const _hoisted_24 = ["id", "checked", "onChange"]
const _hoisted_25 = ["for"]
const _hoisted_26 = { class: "fs-13" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_29 = { class: "fs-13" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_32 = { class: "text-muted fs-13" }
const _hoisted_33 = { class: "text-end pe-20" }
const _hoisted_34 = { class: "d-flex align-items-center justify-content-end gap-1" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = ["onClick"]
const _hoisted_37 = ["onClick"]
const _hoisted_38 = ["onClick"]
const _hoisted_39 = { class: "px-15 px-md-20 py-12 border-top" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PaginatorContent = _resolveComponent("PaginatorContent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[6] || (_cache[6] = [
          _createElementVNode("div", {
            class: "spinner-border text-primary",
            role: "status",
            style: {"width":"5rem","height":"5rem"}
          }, [
            _createElementVNode("span", { class: "visually-hidden" }, "Chargement...")
          ], -1)
        ])))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "card mb-25 border-0 rounded-0 bg-white letter-spacing",
      style: _normalizeStyle(_ctx.loading ? { 'pointer-events': 'none', opacity: '0.08' } : {})
    }, [
      _createElementVNode("div", _hoisted_2, [
        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "d-flex align-items-center gap-2 flex-wrap" }, [
          _createElementVNode("h5", { class: "mb-0 fw-bold" }, [
            _createElementVNode("i", { class: "flaticon-users-group me-2 text-primary" }),
            _createTextVNode(" Clients ")
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[8] || (_cache[8] = _createElementVNode("i", {
              class: "flaticon-search position-absolute top-50 translate-middle-y text-muted",
              style: {"left":"10px","font-size":"13px","pointer-events":"none"}
            }, null, -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control form-control-sm rounded-1 ps-4",
              style: {"min-width":"240px"},
              placeholder: "Rechercher un client...",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.users.searchTerm) = $event)),
              onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleSearch && _ctx.handleSearch(...args)))
            }, null, 544), [
              [_vModelText, _ctx.users.searchTerm]
            ]),
            (_ctx.users.searchTerm)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn-sm position-absolute top-50 translate-middle-y end-0 me-1 p-0 border-0 bg-transparent text-muted",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => {_ctx.users.searchTerm = ''; _ctx.handleSearch()})
                }, _cache[7] || (_cache[7] = [
                  _createElementVNode("i", { class: "ri-close-line" }, null, -1)
                ])))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("button", {
            class: "btn btn-outline-primary btn-sm fw-medium d-flex align-items-center gap-1",
            disabled: _ctx.countsLoading || _ctx.rows.length === 0,
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.fetchCounts(_ctx.rows.map((r) => r.id))))
          }, [
            (_ctx.countsLoading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6))
              : (_openBlock(), _createElementBlock("i", _hoisted_7)),
            _cache[9] || (_cache[9] = _createTextVNode(" Afficher colis / factures ", -1))
          ], 8, _hoisted_5),
          (_ctx.auth.can('ADD_CUSTOMER'))
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: "/add-customer",
                class: "btn btn-success btn-sm fw-medium d-flex align-items-center gap-1"
              }, {
                default: _withCtx(() => _cache[10] || (_cache[10] = [
                  _createElementVNode("i", { class: "flaticon-plus fs-12" }, null, -1),
                  _createTextVNode(" Nouveau client ", -1)
                ])),
                _: 1,
                __: [10]
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("table", _hoisted_11, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _cache[14] || (_cache[14] = _createElementVNode("th", {
                    class: "ps-20 text-uppercase fs-12 text-muted fw-semibold",
                    style: {"width":"52px"}
                  }, "#", -1)),
                  _cache[15] || (_cache[15] = _createElementVNode("th", {
                    class: "text-uppercase fs-12 text-muted fw-semibold",
                    style: {"width":"56px"}
                  }, "Logo", -1)),
                  _cache[16] || (_cache[16] = _createElementVNode("th", { class: "text-uppercase fs-12 text-muted fw-semibold" }, "Magasin / Infos", -1)),
                  _cache[17] || (_cache[17] = _createElementVNode("th", { class: "text-uppercase fs-12 text-muted fw-semibold" }, "Contact", -1)),
                  _cache[18] || (_cache[18] = _createElementVNode("th", { class: "text-uppercase fs-12 text-muted fw-semibold" }, "Statut", -1)),
                  _createElementVNode("th", {
                    class: "text-uppercase fs-12 text-muted fw-semibold sortable",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toggleSort('colis')))
                  }, [
                    _cache[12] || (_cache[12] = _createTextVNode(" Colis ", -1)),
                    _createElementVNode("i", {
                      class: _normalizeClass(_ctx.sortIcon('colis'))
                    }, null, 2)
                  ]),
                  _createElementVNode("th", {
                    class: "text-uppercase fs-12 text-muted fw-semibold sortable",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.toggleSort('invoices')))
                  }, [
                    _cache[13] || (_cache[13] = _createTextVNode(" Factures ", -1)),
                    _createElementVNode("i", {
                      class: _normalizeClass(_ctx.sortIcon('invoices'))
                    }, null, 2)
                  ]),
                  _cache[19] || (_cache[19] = _createElementVNode("th", { class: "text-uppercase fs-12 text-muted fw-semibold" }, "Création", -1)),
                  _cache[20] || (_cache[20] = _createElementVNode("th", { class: "text-uppercase fs-12 text-muted fw-semibold text-end pe-20" }, "Actions", -1))
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_ctx.rows.length === 0 && !_ctx.loading)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_12, _cache[21] || (_cache[21] = [
                      _createElementVNode("td", {
                        colspan: "9",
                        class: "text-center py-40 text-muted"
                      }, [
                        _createElementVNode("i", { class: "flaticon-users-group fs-40 d-block mb-10 opacity-25" }),
                        _createTextVNode(" Aucun client trouvé ")
                      ], -1)
                    ])))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row, i) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: row.id,
                    class: "border-top customer-row"
                  }, [
                    _createElementVNode("td", _hoisted_13, _toDisplayString((_ctx.users.current_page - 1) * _ctx.users.per_page + i + 1), 1),
                    _createElementVNode("td", null, [
                      (row.logo && !_ctx.imgErrors[row.id])
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: row.logo,
                            class: "customer-avatar",
                            alt: row.store,
                            onError: ($event: any) => (_ctx.imgErrors[row.id] = true)
                          }, null, 40, _hoisted_14))
                        : (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: "customer-avatar-letter",
                            style: _normalizeStyle({ background: _ctx.getColor(row.store) })
                          }, _toDisplayString(_ctx.firstLetter(row.store)), 5))
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", _hoisted_15, _toDisplayString(row.store), 1),
                      _createElementVNode("span", _hoisted_16, _toDisplayString(row.name), 1),
                      (row.store_name)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_17, "(" + _toDisplayString(row.store_name) + ")", 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        (row.phone)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                              _cache[22] || (_cache[22] = _createElementVNode("i", { class: "ri-phone-line text-muted me-1" }, null, -1)),
                              _createTextVNode(_toDisplayString(row.phone), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (row.email)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_21, [
                              _cache[23] || (_cache[23] = _createElementVNode("i", { class: "ri-mail-line me-1" }, null, -1)),
                              _createTextVNode(_toDisplayString(row.email), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (row.city)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_22, [
                              _cache[24] || (_cache[24] = _createElementVNode("i", { class: "ri-map-pin-line me-1" }, null, -1)),
                              _createTextVNode(_toDisplayString(row.city), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          class: "switch-input",
                          id: 'sw-' + row.id,
                          checked: row.active,
                          onChange: ($event: any) => (_ctx.toggleAdActive(row))
                        }, null, 40, _hoisted_24),
                        _createElementVNode("label", {
                          class: "switch-label",
                          for: 'sw-' + row.id
                        }, null, 8, _hoisted_25)
                      ]),
                      _createElementVNode("span", {
                        class: _normalizeClass(["d-block fs-11 mt-1", row.active ? 'text-success' : 'text-muted'])
                      }, _toDisplayString(row.active ? 'Actif' : 'Inactif'), 3)
                    ]),
                    _createElementVNode("td", _hoisted_26, [
                      (_ctx.counts.colis[row.id] !== undefined)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(_ctx.counts.colis[row.id]), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_28, "—"))
                    ]),
                    _createElementVNode("td", _hoisted_29, [
                      (_ctx.counts.invoices[row.id] !== undefined)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(_ctx.counts.invoices[row.id]), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_31, "—"))
                    ]),
                    _createElementVNode("td", _hoisted_32, _toDisplayString(_ctx.getDate(row.created_at)), 1),
                    _createElementVNode("td", _hoisted_33, [
                      _createElementVNode("div", _hoisted_34, [
                        (_ctx.auth.can('CUSTOMERS') && _ctx.auth.can('CONNEXION_CUSTOMER'))
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "action-btn action-btn--primary",
                              title: "Login client",
                              onClick: ($event: any) => (_ctx.adminLogin(row))
                            }, _cache[25] || (_cache[25] = [
                              _createElementVNode("i", { class: "ph ph-sign-in" }, null, -1)
                            ]), 8, _hoisted_35))
                          : _createCommentVNode("", true),
                        (_ctx.auth.can('CUSTOMERS') && _ctx.auth.can('EDIT_CUSTOMER'))
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              class: "action-btn action-btn--warning",
                              title: "Modifier",
                              onClick: ($event: any) => (_ctx.$router.push({ name: 'EditCustomerPage', params: { id: row.id } }))
                            }, _cache[26] || (_cache[26] = [
                              _createElementVNode("i", { class: "flaticon-pen" }, null, -1)
                            ]), 8, _hoisted_36))
                          : _createCommentVNode("", true),
                        (_ctx.auth.can('CUSTOMERS'))
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 2,
                              class: "action-btn action-btn--info",
                              title: "Historique",
                              onClick: ($event: any) => (_ctx.$router.push({ name: 'HistoryCustomerPage', params: { id: row.id } }))
                            }, _cache[27] || (_cache[27] = [
                              _createElementVNode("i", { class: "flaticon-clock" }, null, -1)
                            ]), 8, _hoisted_37))
                          : _createCommentVNode("", true),
                        (_ctx.auth.can('CUSTOMERS'))
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 3,
                              class: "action-btn action-btn--secondary",
                              title: "Équipes",
                              onClick: ($event: any) => (_ctx.$router.push({ name: 'StaffCustomerPage', params: { id: row.id } }))
                            }, _cache[28] || (_cache[28] = [
                              _createElementVNode("i", { class: "ph ph-users-four" }, null, -1)
                            ]), 8, _hoisted_38))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_39, [
          _createVNode(_component_PaginatorContent, {
            pagination: _ctx.users,
            offset: 9,
            onPaginate: _ctx.fetchData
          }, null, 8, ["pagination", "onPaginate"])
        ])
      ])
    ], 4)
  ], 64))
}